import { ShieldAlert, X } from "lucide-react";

export function PhiBanner({ onDismiss }: { onDismiss: () => void }) {
  return (
    <div
      role="alert"
      className="relative flex items-center justify-center gap-2 border-b border-amber-200 bg-amber-50 px-12 py-2.5 text-amber-900"
    >
      <ShieldAlert className="w-4 h-4 text-amber-700 shrink-0" />
      <div className="text-[13px] leading-5 text-center">
        <span className="font-semibold">Demo only — no HIPAA safeguards.</span> Strip PHI from any
        real uploads. Synthetic data is fully fabricated; no real patient information is used.
      </div>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss notice"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded hover:bg-amber-100 text-amber-700 hover:text-amber-900 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
